import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"
import { useAppBridge } from "@shopify/app-bridge-react";
import { Redirect } from "@shopify/app-bridge/actions";
import useHttpUtility from "../utilities/useHttpUtility";
import LoadingScreen from "../components/LoadingScreen"
import AccountDetails from "../components/AccountDetails"
import AppRequirements from "../components/AppRequirements";
export default function PageHome() {

    const navigate = useNavigate();
    const http = useHttpUtility();
    const app = useAppBridge();
    const [summary, setSummary] = useState(null);

    useEffect(() => {
        http.get("/api/Shops/Summary", (d) => {
            if (d?.reauthInstallUrl) {
                try {
                    Redirect.create(app).dispatch(Redirect.Action.REMOTE, d.reauthInstallUrl);
                } catch (e) {
                    console.log("App Bridge redirect failed, falling back to top-level navigation", e);
                    try { window.top.location.replace(d.reauthInstallUrl); } catch (_) { /* noop */ }
                }
                return;
            }
            d?.contact
                ? setSummary(d)
                : navigate(`Login${window.location.search}`);
        })
    }, []);

    return (<>
        {
            !summary
                ? <LoadingScreen isFullScreen={true} />
                : <div className="page page-home">

                    <AccountDetails client={summary.client} contact={summary.contact} />

                    <h1>Welcome to the Urgent Couriers Shopify App</h1>
                    <div className="padding-bottom">
                        <p>If you are a client of Urgent and would like any support setting up the app visit <a href="https://urgent.co.nz" target="_blank"><b>https://urgent.co.nz</b></a> and hit the live chat button to speak with a member of the sales team.</p>
                    </div>

                    <AppRequirements carrierCalculatedShippingRegistered={summary?.carrierCalculatedShippingRegistered} webhooksRegistered={summary?.webhooksRegistered} />

                    <div>
                        <h2>Setup Instructions</h2>
                        <ul>
                            <li>To get started, you will first need to set up some delivery windows by clicking the <b>Windows</b> link on the right side of the page and clicking the plus button to create a new delivery window.</li>
                            <li>Next Select <b>Checkout Windows</b> if you want the Urgent App to price shipping on the Checkout Page, or select <b>Post Checkout Booking Windows</b> if you have repeating subscriptions that need to be shipped. If you have both options, you will need to set up two different window groups.</li>
                            <li>You can apply different rules and set different delivery windows for the region you want to be serviced.</li>
                            <li>If you need assistance setting up your delivery windows you can book a free implementation meeting with our team <a href="https://calendly.com/georgehampton/urgent-couriers-shopify-implementation" target="_blank"><b>here</b></a>.</li>
                        </ul>
                    </div>

                </div>
        }
    </>);
}